var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTransactionMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FBFCB33B-977B-429C-B756-F19F0941EBDA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money",
    transform: "translate(-300.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transaction-minus",
    transform: "translate(300.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93952942,21.6500015 L8.92951965,20.3000031 C8.71951966,20.0200031 8.43952638,19.8600002 8.13952637,19.8400002 C7.83952636,19.8300002 7.53953002,19.9599991 7.29953003,20.2099991 L6.74952698,19.7000008 L7.29953003,20.2099991 C5.85952997,21.75 4.74952817,21.6299982 4.2195282,21.4199982 C3.67952818,21.2099982 2.76953125,20.5199993 2.76953125,18.2999992 L2.76953125,7.04000092 C2.76953125,2.60000086 4.04953241,1.25 8.23953247,1.25 L15.79953,1.25 C19.9895301,1.25 21.2695312,2.60000086 21.2695312,7.04000092 L21.2695312,18.2999992 C21.2695312,20.5099993 20.3595343,21.1999982 19.8195343,21.4199982 C19.2895343,21.6299982 18.1895325,21.75 16.7395325,20.2099991 C16.4995325,19.9499991 16.1995264,19.8200002 15.8895264,19.8400002 C15.5895264,19.8600002 15.2995233,20.0200031 15.0895233,20.3000031 L14.0795288,21.6500015 C13.5395288,22.3500015 12.7795269,22.75 11.999527,22.75 C11.219527,22.75 10.4595294,22.3500015 9.93952942,21.6500015 Z M8.20953369,18.3300018 C8.9495337,18.3700018 9.6495221,18.7599994 10.1195221,19.3899994 L11.1295319,20.7399979 C11.6195319,21.3899978 12.3695276,21.3899978 12.8595276,20.7399979 L13.8695221,19.3899994 C14.3495221,18.7599994 15.0395203,18.3700018 15.7895203,18.3300018 C16.5395203,18.2900018 17.2695312,18.6000003 17.8095245,19.1800003 C18.5695245,19.9900003 19.0595325,20.0899966 19.2395325,20.0199966 C19.4795325,19.9199966 19.7395325,19.3399992 19.7395325,18.2999992 L19.7395325,7.04000092 C19.7395325,3.43000102 19.1095312,2.75 15.7695312,2.75 L8.20953369,2.75 C4.86953378,2.75 4.23953247,3.43000102 4.23953247,7.04000092 L4.23953247,18.2999992 C4.23953247,19.3499992 4.49953248,19.9299966 4.73953247,20.0199966 C4.90953247,20.0899966 5.40952516,19.9900003 6.16952515,19.1800003 C6.71952516,18.6300003 7.38952881,18.3300018 8.07952881,18.3300018 C8.11952881,18.3300018 8.16953369,18.3300018 8.20953369,18.3300018 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25,10.75 C8.84,10.75 8.5,10.41 8.5,10 C8.5,9.59 8.84,9.25 9.25,9.25 L14.75,9.25 C15.16,9.25 15.5,9.59 15.5,10 C15.5,10.41 15.16,10.75 14.75,10.75 L9.25,10.75 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTransactionMinus);
export default __webpack_public_path__ + "static/media/vuesax-outline-transaction-minus.68ebbc997249554b8d7eb1e93b9599de.svg";
export { ForwardRef as ReactComponent };